

(function() {
  'use strict';

  class ProductMain {
    constructor() {
      this.section = document.querySelector('[data-product-main]');
      if (!this.section) return;

     
      this.thumbnails = this.section.querySelectorAll('[data-thumbnail-index]');
      this.mediaItems = this.section.querySelectorAll('[data-media-index]');
      this.teeSlides = this.section.querySelectorAll('.tee-slide');
      this.hasTeeinblue = this.teeSlides.length > 0;
      this.currentIndex = 0;
      this.totalImages = 0;
      
   
      this.init();
      

      if (this.hasTeeinblue) {
        this.watchTeeinblueApp();
      }
    }
    
    watchTeeinblueApp() {
    
      const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { 
          
                const mockupItems = node.querySelectorAll ? node.querySelectorAll('.tee-mockup-item') : [];
                const hasTeeinblueContent = node.classList?.contains('tee-mockup-item') || 
                                           node.classList?.contains('tee-platform-mockup') ||
                                           node.classList?.contains('tee-mockup-zoomable') ||
                                           node.tagName === 'IMG' ||
                                           mockupItems.length > 0;
                
                if (hasTeeinblueContent || node.closest('.tee-platform-mockup') || node.closest('.tee-mockup-item')) {
                  shouldUpdate = true;
                }
              }
            });
          }
          
       
          if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
            shouldUpdate = true;
          }
        });
        
        if (shouldUpdate) {
         
          setTimeout(() => {
            this.teeSlides = this.section.querySelectorAll('.tee-slide');
           
            this.teeSlides.forEach((slide, i) => {
              if (!slide.style.display || slide.style.display !== 'none') {
                slide.style.display = '';
              }
            });
       
            const activeThumbnail = this.section.querySelector('.product-main__thumbnail--active');
            if (activeThumbnail) {
              const index = parseInt(activeThumbnail.dataset.thumbnailIndex);
              this.setActiveImage(index);
            }
          }, 150);
        }
      });
      
  
      const teeSliderTrack = this.section.querySelector('.tee-slider__track');
      if (teeSliderTrack) {
        observer.observe(teeSliderTrack, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['src', 'srcset', 'style', 'class']
        });
      }
      
     
      const appBlocks = this.section.querySelectorAll('[data-shopify-app-block], [id*="tee"], [class*="tee-app"]');
      appBlocks.forEach(block => {
        observer.observe(block, {
          childList: true,
          subtree: true,
          attributes: true
        });
      });
      

      const mainImageContainer = this.section.querySelector('[data-main-image]');
      if (mainImageContainer) {
        observer.observe(mainImageContainer, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }
      
     
      let checkCount = 0;
      const maxChecks = 30;
      const checkInterval = setInterval(() => {
        checkCount++;
        const mockupItems = this.section.querySelectorAll('.tee-mockup-item');
        const teeSlides = this.section.querySelectorAll('.tee-slide');
        
     
        teeSlides.forEach(slide => {
          if (slide.style.display === 'none') {
            slide.style.display = '';
          }
        });
        
        if (mockupItems.length > 0 || checkCount >= maxChecks) {
          clearInterval(checkInterval);
     
          this.teeSlides = this.section.querySelectorAll('.tee-slide');
          this.hasTeeinblue = this.teeSlides.length > 0;
          
         
          const activeThumbnail = this.section.querySelector('.product-main__thumbnail--active');
          if (activeThumbnail) {
            const index = parseInt(activeThumbnail.dataset.thumbnailIndex);
            this.setActiveImage(index);
          }
        }
      }, 100);
    }

    init() {
   
      if (this.thumbnails.length > 0) {
        this.initImages();
      }
      
    
      this.initCountdown();
      this.initCollapsible();
      this.initVariants(); 
      this.initButtons();
      this.initSizeComparison();
    }

    initImages() {
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          const index = parseInt(thumbnail.dataset.thumbnailIndex);
          this.currentIndex = index;
          this.setActiveImage(index);
        });
      });


      this.setupArrowNavigation();

      
      this.initFancybox();
    }

    setupArrowNavigation() {
      const prevArrow = this.section.querySelector('[data-image-prev]');
      const nextArrow = this.section.querySelector('[data-image-next]');
      const imageLinks = this.section.querySelectorAll('[data-fancybox]');
      this.totalImages = imageLinks.length;

      if (prevArrow && nextArrow && this.totalImages > 0) {
        prevArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.currentIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages;
          this.navigateToImage(this.currentIndex);
        });

        nextArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.currentIndex = (this.currentIndex + 1) % this.totalImages;
          this.navigateToImage(this.currentIndex);
        });

    
        this.thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', () => {
            this.currentIndex = parseInt(thumbnail.dataset.thumbnailIndex);
          });
        });
      }
    }

    navigateToImage(index) {
      const imageLinks = this.section.querySelectorAll('[data-fancybox]');
      if (imageLinks[index]) {
        this.setActiveImage(index);
      
        if (typeof Fancybox !== 'undefined' && Fancybox.getInstance()) {
          Fancybox.getInstance().jumpTo(index);
        }
      }
    }

    initFancybox() {
     
      if (typeof Fancybox === 'undefined') {
        setTimeout(() => this.initFancybox(), 100);
        return;
      }

      Fancybox.bind('[data-fancybox="product-main-images"]', {
        Thumbs: {
          autoStart: false,
        },
        Toolbar: {
          display: {
            left: ['infobar'],
            middle: [],
            right: ['slideshow', 'download', 'thumbs', 'close'],
          },
        },
        on: {
          reveal: (fancybox, slide) => {
      
            this.currentIndex = slide.index;
            this.setActiveImage(slide.index);
          },
        },
      });
    }

    setActiveImage(index) {
      this.currentIndex = index;

     
      this.thumbnails.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('product-main__thumbnail--active');
        } else {
          thumb.classList.remove('product-main__thumbnail--active');
        }
      });

      if (this.hasTeeinblue) {
     
        this.teeSlides = this.section.querySelectorAll('.tee-slide');
        
      
        this.teeSlides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.add('tee-slide--active');
            slide.style.opacity = '1';
            slide.style.left = '0px';
            slide.style.transition = 'opacity 0.4s ease, left 0.4s ease';
            slide.style.pointerEvents = 'auto';
            slide.style.zIndex = '1';
          } else {
            slide.classList.remove('tee-slide--active');
            slide.style.opacity = '0';
            slide.style.left = '0px';
            slide.style.transition = 'opacity 0.4s ease, left 0.4s ease';
            slide.style.pointerEvents = 'none';
            slide.style.zIndex = '0';
          }
        });
      } else {
 
        this.mediaItems.forEach((media, i) => {
          if (i === index) {
            media.classList.add('product-main__media--active');
          } else {
            media.classList.remove('product-main__media--active');
          }
        });
      }
    }

    initCountdown() {
      const countdowns = this.section.querySelectorAll('[data-countdown]');
      
      countdowns.forEach(countdown => {
        const endDate = countdown.dataset.endDate;
        if (!endDate) return;

        const updateCountdown = () => {
          const now = new Date().getTime();
          const end = new Date(endDate).getTime();
          const distance = end - now;

          if (distance < 0) {
          
            countdown.querySelectorAll('[data-countdown-days], [data-countdown-hours], [data-countdown-minutes], [data-countdown-seconds]').forEach(el => {
              el.textContent = '0';
            });
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const daysEl = countdown.querySelector('[data-countdown-days]');
          const hoursEl = countdown.querySelector('[data-countdown-hours]');
          const minutesEl = countdown.querySelector('[data-countdown-minutes]');
          const secondsEl = countdown.querySelector('[data-countdown-seconds]');

          if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        };

    
        updateCountdown();

    
        setInterval(updateCountdown, 1000);
      });
    }

    initCollapsible() {
      const collapsibles = this.section.querySelectorAll('[data-collapsible]');
      
      collapsibles.forEach(item => {
        const button = item.querySelector('.product-main__collapsible-button');
        if (!button) return;

        button.addEventListener('click', () => {
          const isOpen = item.classList.contains('product-main__collapsible-item--open');
          
          if (isOpen) {
            item.classList.remove('product-main__collapsible-item--open');
          } else {
            item.classList.add('product-main__collapsible-item--open');
          }
        });
      });
    }


    initVariants() {
      const variantsContainer = this.section.querySelector('[data-variants]');
      const variantOptions = this.section.querySelectorAll('.product-main__variant-option');
      const variantIdInput = this.section.querySelector('[data-variant-id]');
      
      if (!variantIdInput || variantOptions.length === 0 || !variantsContainer) return;

      let variants = [];
      try {
        const variantsData = variantsContainer.dataset.productVariants;
        if (variantsData) {
          variants = JSON.parse(variantsData);
        }
      } catch (e) {
        console.error('Variant data parse error:', e);
        return;
      }

      variantOptions.forEach(option => {
        option.addEventListener('click', () => {
          const optionIndex = parseInt(option.dataset.optionIndex);
          const optionValue = option.dataset.optionValue;

    
          const group = option.closest('.product-main__variant-group');
          
          if (group) {
        
            let labelSpan = group.querySelector('.product-main__selected-value');
            
            
            if (!labelSpan) {
              labelSpan = group.querySelector('.product-main_selected-value');
            }
            
          
            if (!labelSpan && option.dataset.optionName) {
               labelSpan = this.section.querySelector(`[data-selected-value-for="${option.dataset.optionName.replace(/"/g, '\\"')}"]`);
            }
            
            if (labelSpan) {
              labelSpan.textContent = optionValue;
              labelSpan.style.opacity = '0.5';
              setTimeout(() => { labelSpan.style.opacity = '1'; }, 150);
            }
            
          
            group.querySelectorAll('.product-main__variant-option').forEach(opt => {
               opt.classList.remove('product-main__variant-option--active');
            });
          }

        
          option.classList.add('product-main__variant-option--active');

         
          const selectedOptions = [];
          this.section.querySelectorAll('.product-main__variant-option--active').forEach(activeOpt => {
            const idx = parseInt(activeOpt.dataset.optionIndex);
            const val = activeOpt.dataset.optionValue;
            selectedOptions[idx] = val;
          });

          const variant = this.findVariant(variants, selectedOptions);
          
          if (variant) {
            if (variantIdInput) {
              variantIdInput.value = variant.id;
              variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
           
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', newUrl);
          }
        });
      });
    }

    findVariant(variants, selectedOptions) {
      for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        let matches = true;
        
        for (let j = 0; j < variant.options.length; j++) {
          const variantOptionValue = variant.options[j];
          const selectedValue = selectedOptions[j];
          
          if (variantOptionValue !== selectedValue) {
            matches = false;
            break;
          }
        }
        
        if (matches) {
          return variant;
        }
      }
      
      return null;
    }

    initButtons() {
      const buyNowButton = this.section.querySelector('[data-buy-now]');
      const addToCartForm = this.section.querySelector('[data-product-form]');

      // NOT: Form submit işlemi product-main.liquid içindeki upsell kodu tarafından yapılıyor
      // Burada tekrar yaparsak çift ekleme olur

      if (buyNowButton && addToCartForm) {
        buyNowButton.addEventListener('click', (e) => {
          e.preventDefault();
          
          const formData = new FormData(addToCartForm);
          
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('Error:', error);
          });
        });
      }
    }

    initSizeComparison() {
      const popupButtons = this.section.querySelectorAll('[data-size-popup]');
      
      if (popupButtons.length === 0) return;

      popupButtons.forEach(button => {
        const blockId = button.getAttribute('data-popup-block-id');
        if (!blockId) return;

        const popupOverlay = this.section.querySelector(`[data-size-popup-overlay][data-popup-block-id="${blockId}"]`);
        if (!popupOverlay) return;

        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          popupOverlay.setAttribute('data-open', 'true');
          document.body.style.overflow = 'hidden';
        });

        const popupClose = popupOverlay.querySelector('[data-size-popup-close]');
        if (popupClose) {
          popupClose.addEventListener('click', () => {
            popupOverlay.setAttribute('data-open', 'false');
            document.body.style.overflow = '';
          });
        }

        popupOverlay.addEventListener('click', (e) => {
          const popupContent = popupOverlay.querySelector('.product-main__size-popup-content');
          
          if (e.target === popupContent || e.target.closest('.product-main__size-popup-content') || e.target.closest('[data-size-popup-close]')) {
            return;
          }
          
          popupOverlay.setAttribute('data-open', 'false');
          document.body.style.overflow = '';
        });
        
        const popupContent = popupOverlay.querySelector('.product-main__size-popup-content');
        if (popupContent) {
          popupContent.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openPopup = this.section.querySelector('[data-size-popup-overlay][data-open="true"]');
          if (openPopup) {
            openPopup.setAttribute('data-open', 'false');
            document.body.style.overflow = '';
          }
        }
      });
    }
  }

 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductMain();
    });
  } else {
    new ProductMain();
  }


  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.hasAttribute('data-product-main')) {
          new ProductMain();
        }
      }
    });
  }
})();